export const getInitialState = () => ({
    fetchStatus: "initial"
});
